// src/components/EvaluationContainer/EvaluationContainer.js
import React, { useState, useEffect } from "react";
import { fetchWithAuth } from "../../utils/api";
import "./style.css";
import { CalenderIcon } from "../../assets/icons/icons";
import { useConfig } from "../../contexts/ConfigContext";

export default function EvaluationContainer() {
  const [activeEval, setActiveEval] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { config } = useConfig();
  const API_BASE = config.apiBase;

  useEffect(() => {
    (async () => {
      try {
        // 2️⃣ fetch manager's evaluations
        const res = await fetchWithAuth(`${API_BASE}/evaluation`);

        // Handle 401 Unauthorized - Token expired or invalid
        if (res.status === 401) {
          console.warn("🔐 Token expired or invalid");
          localStorage.removeItem("userRole");
          localStorage.removeItem("userPermissions");
          window.location.href = "/login";
          return;
        }

        const json = await res.json();
        if (!res.ok) throw new Error(json.error || res.statusText);

        // 3️⃣ filter to in‑progress (end_date > now)
        const now = new Date();
        const inProg = json.evaluations
          .filter((ev) => new Date(ev.end_date) > now);

        if (inProg.length) {
          // pick the one ending soonest
          inProg.sort(
            (a, b) => new Date(a.end_date) - new Date(b.end_date)
          );
          const next = inProg[0];
          const msPerDay = 1000 * 60 * 60 * 24;
          const daysLeft = Math.ceil(
            (new Date(next.end_date) - now) / msPerDay
          );
          setActiveEval({
            name: next.name,
            daysLeft,
          });
        } else {
          setActiveEval(null);
        }
      } catch (err) {
        console.error(err);
        setActiveEval(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="action-tile">
        <div className="action-container">
          <p>Loading active evaluation…</p>
        </div>
      </div>
    );
  }

  const isActive = Boolean(activeEval);

  return (
    <div className="action-tile">
      {isActive ? (
        <>
          <p className="action-info">
            Evaluation in progress: <strong>{activeEval.name}</strong>
          </p>
          <div className="action-container">
            <div className="action-title-container">
              <h2 className="action-title-alt">{activeEval.daysLeft}</h2>
              <p className="action-subtitle">Day(s) Remaining</p>
            </div>
            <div className="action-icon-container">
              <CalenderIcon className="action-icon" />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="action-container">
            <div className="action-title-container">
              <h2 className="action-title">No Current Evaluations</h2>
            </div>
            <div className="action-icon-container">
              <CalenderIcon className="action-icon" />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
